import { CUSTOM_QUESTION_TYPES_ID } from "repoV2/features/CustomQuestions/constants/CustomQuestionsTypes.constants";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";

/**
 * This utility takes the question type and answer and checks if the answer is present or not
 * @param questionType Type of the question
 * @param answer Answer value
 * @returns check whether the answer to the question is valid or not
 */
export const checkCustomQuestionAnswerValid = (
    questionType: number,
    answer: string | string[]
) => {
    if (questionType === CUSTOM_QUESTION_TYPES_ID.MULTI_OPTION_SELECT) {
        return !checkIsArrayEmpty(Array.isArray(answer) ? answer : []);
    }
    return Boolean(answer);
};
